import { render, staticRenderFns } from "./SetDisplay.vue?vue&type=template&id=60f81cad"
import script from "./SetDisplay.vue?vue&type=script&lang=ts"
export * from "./SetDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports